module.exports = __webpack_public_path__ + "img/passInput.2240aace.svg";